import { useEffect, useState, useMemo } from 'react';
import * as chakra from '@chakra-ui/react';

import { useNavigate,
  BrowserRouter as Router,
  useLocation
} from "react-router-dom";

import Header from '../../components/molecules/Header';
import Button from "../../components/atoms/Button";
import Input from "../../components/atoms/Input";
import MoneyInput from '../../components/atoms/MoneyInput';
import Select from '../../components/atoms/Select';

import { getUserInformations } from "../../services/authServices";
import { getAliquotEfectiveCompany } from "../../services/prePaymentServices";
import { getCompanyDasInfo } from "../../services/companyServices";
import convertCurrency from '../../utils/convertCurrency';

import { AliquotEfectiveStyle } from './style';

const AliquotEfective = () => {
  const [userName, setUserName] = useState('');
  const [cityName, setCityName] = useState(''); 
  const [cnpj, setCnpj] = useState('');
  const [aliquot, setAliquot] = useState(0);
  const [aliquotSimples, setAliquotSimples] = useState(0);
  const [value, setValue] = useState('');
  const [withheld, setWithheld] = useState(0);
  const [netOfTax, setNetOfTax] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [monthSelected, setMonthSelected] = useState();
  const [yearSelected, setYearSelected] = useState();
  const [optante, setOptante] = useState(false);
  const [valueApurado, setValueApurado] = useState();
  const [DasInformation, setDasInformation] = useState();

  const monthsOptions = [
    {label: 'Janeiro', value: 1},
    {label: 'Fevereiro', value: 2},
    {label: 'Março', value: 3},
    {label: 'Abril', value: 4},
    {label: 'Maio', value: 5},
    {label: 'Junho', value: 6},
    {label: 'Julho', value: 7},
    {label: 'Agosto', value: 8},
    {label: 'Setembro', value: 9},
    {label: 'Outubro', value: 10},
    {label: 'Novembro', value: 11},
    {label: 'Dezembro', value: 12},
  ];

  const yearOptions = [
    {label: '2019', value: 2019},
    {label: '2020', value: 2020},
    {label: '2021', value: 2021},
    {label: '2022', value: 2022},
    {label: '2023', value: 2023},
    {label: '2024', value: 2024}
  ]

  const toast = chakra.useToast();

  async function searchCompany (cnpj) {
    setIsLoading(true);

    await getCompanyDasInfo({ cnpj: cnpj }).then(response => {
      console.log(response);
      setDasInformation(response.data);
      if(response == undefined) {
        toast({
          title: 'Empresa sem dados informados',
          status: 'success',
          position: 'top-right',
          isClosable: true,
        });
      }
    }).catch(error => {
      console.log(error);
    })

    if(monthSelected == undefined) {
      toast({
        title: 'Selecione o mês da consulta!',
        status: 'error',
        position: 'top-right',
        isClosable: true,
      });

      if(yearSelected == undefined) {
        toast({
          title: 'Selecione o ano da consulta!',
          status: 'error',
          position: 'top-right',
          isClosable: true,
        });
      }
    }

    await getAliquotEfectiveCompany({ cnpj: cnpj, month: monthSelected?.value, year: yearSelected?.value }).then(response => {
      setAliquot(response.body.aliquot_efective);
      setAliquotSimples(response.body.aliquot_simples);
      setOptante(response.body.optante);
      setValueApurado(`${response.body.value}`);
      setIsLoading(false);
    }).catch(error => {
      setIsLoading(false);
      toast({
        title: 'Empresa com informações insuficientes!',
        status: 'error',
        position: 'top-right',
        isClosable: true,
      });
    });
  }

  function calculate () {
    const valueConvert = parseFloat(convertCurrency(value))
    const aliquotConvert = (parseFloat(aliquot) / 100 );

    const withheld_tax = (valueConvert * (aliquotConvert)).toFixed(2);
    const net_of_tax = (valueConvert - (valueConvert * (aliquotConvert))).toFixed(2);

    setWithheld(withheld_tax);
    setNetOfTax(net_of_tax);
  }

  useEffect(() => {
    (async () => {
      await getUserInformations({ currentPage: 1 }).then(response => {
        setUserName(response.body.user_name);
        setCityName(response.body.city_name);
      });
    })();
  }, []);
  
  return (
    <section className={AliquotEfectiveStyle.Container}>
      <Header userName={userName} cityName={cityName} />
      <div className={AliquotEfectiveStyle.BodyContainer}>
        <div className='flex flex-col items-center w-3/4 h-auto pt-10'>
          <h2 className='font-semibold'>Digite o CNPJ do fornecedor e selecione o período</h2>
          <div className='flex flex-row items-start justify-between w-full h-auto mt-6'>
            <div className='w-96'>
              <Input label="CNPJ" placeholder={'CNPJ'} value={cnpj} onChange={e => setCnpj(e.target.value)}/>
            </div>
            <div className='w-72 h-auto'>
              <Select placeholder="Mês"
                selectedValue={monthSelected}
                setSelectedValue={(item) => {
                  setMonthSelected(item);
                }}
                options={monthsOptions}/>
            </div>
            <div className='w-72 h-auto'>
              <Select placeholder="Ano"
                selectedValue={yearSelected}
                setSelectedValue={(item) => {
                  setYearSelected(item);
                }}
                options={yearOptions}/>
            </div>
            <div className='w-56 mt-8'>
              <Button isLoading={isLoading} label='Pesquisar' onPress={() => searchCompany(cnpj)} />
            </div>
          </div>
        </div>

        {
          aliquot !== 0 ?
          <>
            <div className='flex flex-col items-center w-3/5 h-auto pt-10'>
              <div className='w-full'>
                <MoneyInput label='Valor da nota' placeholder='Crédito de pagamento' value={value} onChange={e => setValue(e.target.value)} />
              </div>
              <div className='w-full mt-6'>
                <Button label='Calcular' onPress={() => calculate()} />
              </div>
              { aliquotSimples == 0 ?
                <div className='flex flex-col mt-4 items-center'>
                  <span className='text-[#ff0000]'>{`Dados da empresa insuficientes para a consulta no Simples Nacional`}</span>
                  <span className='text-[#ff0000]'>{`Aliquota aplicada será do código tributário do municipio`}</span>
                </div>
                :
                <div></div>
              }
              <div className='w-full mt-6 p-4 border rounded-md'>
                <div className="flex flex-col w-full h-auto mt-6">
                  <div><span>{`Optante pelo Simples Nacional: ${optante == true ? 'Sim': 'Não'}`}</span></div>
                  <div><span>{`Valor apurado nos últimos 12 meses: R$ ${valueApurado?.replace(',', '.')}`}</span></div>
                </div>

                <div className="flex flex-col w-full h-auto mt-6">
                  <div><span>{`Aliquota do Simples: ${aliquotSimples}%`}</span></div>
                  <div><span>{`Aliquota Efetiva ISS: ${aliquot}%`}</span></div>
                </div>

                <div className="flex flex-col w-full h-auto mt-6">
                  <div><span>{`Valor Substituto: R$ ${withheld}`}</span></div>
                  <div><span>{`Valor Liquido: R$ ${netOfTax}`}</span></div>
                </div>
              </div>
              
            </div>
          </>
          :
          <></>
        }
        
        <div className='flex flex-col items-center w-3/5 h-auto pt-10'>
          <div className='flex flex-col w-full p-4 border rounded-md'>
          { DasInformation?.map(DasCallback => {
            return (
              <div className='flex flex-col border p-2 rounded-md mt-2'>
                <span>{`Mês: ${DasCallback.month}`}</span>
                <span>{`Ano: ${DasCallback.year}`}</span>
                <span>{`Valor apurado (12 meses): R$ ${DasCallback.value?.replace(',', '.')}`}</span>
                <span>Atividades Declaradas:</span>
                {DasCallback.activities.map(activitiesCallback => (
                  <div className='w-auto flex flex-row'>
                    <span className='mr-4'>{`Atividade: ${activitiesCallback.activity}`}</span>
                    <span>{`Valor: R$ ${activitiesCallback.value?.replace(',', '.')}`}</span>
                  </div>
                ))}
              </div>
            )
          })}
          </div>
        </div>

        
      </div>
    </section>
  )
}

export default AliquotEfective;